/**
 * 已经在 src/setupProxy.js中配置了代理，
 * 这里通过BaseUrl配置使用哪个代理
 * @type {string}
 */
export const BaseUrl = process.env.REACT_APP_BASE_API_ADR;
export const ReqType = { GET: 'GET', POST: 'POST' };
export const LoginPath = '/login';
